import React, { Component } from 'react'
import { withRouter, Link } from "react-router-dom";
import { Card, Image, Button } from 'react-bootstrap'
import { Scrollbars } from 'react-custom-scrollbars'
import logo from '../../../images/logo.svg'

import './_navbars.scss'
import BrandLogo from "./BrandLogo";
import ExamResultModal from '../exams/ExamResultModal';

const renderThumb = ({ style, ...props }) => {
    const thumbStyle = {
        borderRadius: 6,
        width: '3px',
        backgroundColor: 'rgba(255, 255, 255, 0.1)'
    };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
};

class StudentAssistentExamAsideBar extends Component {
    constructor(props) {
        super(props)
        const questionsData = props.stateData.questions.map((item) => {
            return { ...item, sidebutton: "0" }

        });
        console.log("questionsData", questionsData);
        this.state = {
            questions: questionsData,
            examSubjects: props.stateData.examSubjects
        }
    }
    idFunction(data) {
        let id = parseInt(data + 1);
        return id;
    }
    classNameFunction(data) {
        console.log("classNameFunction", data.attempted, data.status, data.saveandnext);
        let cname = "list-inline-item";
        if (data.attempted != null) {
            cname = "list-inline-item attempted";
        }
        else if (data.status == "skip") {
            cname = "list-inline-item bookmark";
        }
        // else if (data.status == "review") {
        //     cname = "list-inline-item views";
        // }
        else if (data.status == "" && data.saveandnext == "1") {
            cname = "list-inline-item bookmark";
        }
        return cname;

    }
    notViewedCountFunction(data) {

        let wrongA = [];
        let currectA = [];
        let skipA = [];
        for (let i = 0; i < data.length; i++) {
            let idata = data[i];
            if (idata.status == "wrong") {
                const id = idata.id;
                wrongA.push(id);
            }
            else if (idata.status == "currect") {
                const id = idata.id;
                currectA.push(id);
            }
            else if (idata.status == "skip") {
                const id = idata.id;
                skipA.push(id);
            }
            else if (idata.status == "" && idata.saveandnext == "1") {
                const id = idata.id;
                skipA.push(id);
            }

        }

        let nviewed = parseInt(data.length - wrongA.length - currectA.length - skipA.length);
        return nviewed;
    }
    wrongFunction(data) {
        let wrongA = [];
        for (let i = 0; i < data.length; i++) {
            let idata = data[i];
            if (idata.isSubmitted == true) {
                if (idata.status == "wrong") {
                    const id = idata.id;
                    wrongA.push(id);
                }
            }

        }
        return wrongA.length;
    }

    skipFunction(data) {
        let skipA = [];
        console.log("skipFunctiondata", data);
        for (let i = 0; i < data.length; i++) {
            let idata = data[i];
            if (idata.status == "skip" || (idata.status == "" && idata.saveandnext == "1")) {
                console.log("skipskip");
                skipA.push(idata.id);
            }
            // if (idata.status == "" && idata.saveandnext == "1") {
            //     console.log("saveandnext");
            //     skipA.push(idata.id);
            // }
        }
        return skipA.length;
    }
    reviewFunction(data) {
        let skipA = [];
        for (let i = 0; i < data.length; i++) {
            let idata = data[i];
            if (idata.status == "review") {
                const id = idata.id;
                skipA.push(id);
            }
        }
        return skipA.length;
    }
    currentFunction(data) {
        let currectA = [];
        for (let i = 0; i < data.length; i++) {
            let idata = data[i];
            //if (idata.isSubmitted == true) {
            if (idata.attempted != null) {
                const id = idata.id;
                currectA.push(id);
            }
            //}
        }
        return currectA.length;
    }
    subjectFilter = (subtype) => {
        console.log("subtype", subtype);
        const activeSubjects = this.state.examSubjects.map((item) => {
            if (item.id == subtype) {
                return { ...item, active: "active" }

            }
            return { ...item, active: "" }

        });
        this.setState({
            examSubjects: activeSubjects,
        });
        this.props.parentSubjectfilter(subtype);
    }
    render() {
        const lqlength = this.props.stateData.questions.length - 1;
        console.log("pesection", this.state.questions);

        const qudata = this.props.stateData.questions.filter((a) => a.sidebutton == "0");

        //console.log("StudentAssistentExamAsideBar", this.props.stateData);
        return (
            <div id="examAsidebar" className="exam-asidebar">
                <div className="sidebar-header px-3 py-2" style={{display:"flex", justifyContent:"center"}}>
                    <Link
                    //to="/student/home"
                    >
                        {/* <Image className="logo" src={logo} width="100" alt="Image" /> */}
                        <BrandLogo width="159.501" className="logo" />


                    </Link>
                </div>

                <Scrollbars style={{ height: '85vh' }}
                    renderThumbVertical={renderThumb}
                    autoHide
                    autoHideTimeout={500}
                    autoHideDuration={200}>
                    <ul className="assessment-nav-filter p-2">
                        {this.state.examSubjects.map((item, index) => {
                            return (<li className={item.active}>
                                <a onClick={() => this.subjectFilter(item.id)}>{item.subject}</a>
                            </li>);
                        })}
                    </ul>
                    <div className="questionnor_block m-3">
                        <div className="d-flex justify-content-between mb-2 text-dark">
                            <h6>Questions</h6>
                            <h6>{qudata.length}</h6>
                        </div>
                        <Scrollbars style={{ height: 320 }}
                            renderThumbVertical={renderThumb}
                            autoHide
                            autoHideTimeout={500}
                            autoHideDuration={200}>
                            <ul className="questionNos list-inline">
                                {this.props.stateData.questions.map((Data, index) => {
                                    if (Data.sidebutton == "0") {
                                        return (
                                            <li className={this.classNameFunction(Data)} onClick={(e) => this.props.psideQFun(index)}>{this.idFunction(index)}</li>
                                        )
                                    }
                                }
                                )}
                            </ul>
                        </Scrollbars>
                        <div className="mark_status mt-4 d-flex justify-content-between align-items-center">
                            <Card as={Card.Body} className="single_mark align-items-center w-100 h-100 pt-2 pb-1 border-0 p-0 text-center">
                                <span className="icon_status" />
                                <div className="status_name">Not Viewed</div>
                                <div className="status_count">{this.notViewedCountFunction(this.props.stateData.questions)}</div>
                            </Card>
                            {/* <Card as={Card.Body} className="single_mark align-items-center w-100 h-100 pt-2 pb-1 border-0 p-0 text-center">
                                <span className="icon_status views" />
                                <div className="status_name">Review</div>
                                <div className="status_count">{this.reviewFunction(this.props.stateData.questions)}</div>
                            </Card> */}
                            <Card as={Card.Body} className="single_mark align-items-center w-100 h-100 pt-2 pb-1 border-0 p-0 text-center">
                                <span className="icon_status bookmark" />
                                <div className="status_name">Skip</div>
                                <div className="status_count">{this.skipFunction(this.props.stateData.questions)}</div>
                            </Card>
                            <Card as={Card.Body} className="single_mark align-items-center w-100 h-100 pt-2 pb-1 border-0 p-0 text-center">
                                <span className="icon_status attempted" />
                                <div className="status_name">Answered</div>
                                <div className="status_count">{this.currentFunction(this.props.stateData.questions)}</div>
                            </Card>
                        </div>
                    </div>
                </Scrollbars>
                <div className="footer-block pb-3 text-center">
                    <ul className="list-unstyled">
                        {/* <li>
                            {this.props.stateData.index != lqlength ? ("") : (<Button variant="success" className="px-4" onClick={this.props.ParenthandleFormSubmit}>Finish Exam</Button>)}
                        </li> */}
                    </ul>
                </div>

            </div>
        )
    }
}

export default withRouter(StudentAssistentExamAsideBar)
